import React, { useEffect } from "react";
import { Bar, FlexBox, Grid, Page, ShellBar, ShellBarItem, Link, Text, Icon} from "@ui5/webcomponents-react";
import dark_mode from "@ui5/webcomponents-icons/dist/dark-mode";
import light_mode from "@ui5/webcomponents-icons/dist/light-mode";
import nav_back from "@ui5/webcomponents-icons/dist/nav-back";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Home } from "./Home";
import { Main } from "./Main";
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { setTheme } from '@ui5/webcomponents-base/dist/config/Theme.js';
import { ThemingParameters } from "@ui5/webcomponents-react-base";


export function EntsparApp() {
    const navigate = useNavigate();
    const handleLogoClick = () => { navigate("./");};

    const handleDarkMode = () => {
        if (!darkMode) { setTheme("sap_fiori_3_dark") }
        else { setTheme("sap_fiori_3") }
        setDarkMode(!darkMode);
    }
    const [darkMode, setDarkMode] = useState(false);

    const location = useLocation();



    return (
        <>

            <ShellBar

               logo={<img src="icons/image.jpg"/>}
              //  logo={<Icon style={{color:"green"}} icon={light_mode}/>}
                primaryTitle="Entspar Simulator"
               onLogoClick={handleLogoClick}
                
            >
               {/* <Icon slot="logo" name={home} style={{color:ThemingParameters.sapShell_TextColor}}/> */}
               {location.pathname === "/main" &&  <ShellBarItem icon={nav_back} text="Zurück" onClick={handleLogoClick} /> }
               <ShellBarItem icon={darkMode ? light_mode : dark_mode} text={darkMode ? "Heller Modus" : "Dunkler Modus"} onClick={handleDarkMode} />

             
            </ShellBar>
          
           
            <Routes style={{
            backgroundColor: ThemingParameters.sapBackgroundColor}}>
                <Route path="/home" element={<Home />}/>
                <Route path="/main" element={<Main />} />
                <Route path="/" element={<Navigate replace to="/home" />} />
            </Routes>
            <div
             style={{
            backgroundColor: ThemingParameters.sapBackgroundColor,
           
            bottom:0,
            width:"100%",
            height:"700px"
        }}
      ></div>
      
            <Bar design="Footer"
            style={{bottom: 0}}
  startContent={<><Link href="https://www.behavioral-finance.de/" target="_blank" rel="noreferrer">www.behavioral-finance.de</Link></>}
  endContent={<><Link href="https://www.behavioral-finance.de/impressum" target="_blank" rel="noreferrer">Impressum</Link><Text> | </Text><Link href="https://www.behavioral-finance.de/datenschutz/" target="_blank" rel="noreferrer">Datenschutz</Link></>}
>

</Bar>
        </>
    );
}

